import { transformChart } from "../Displays/Chart";
import { transformGraph } from "../Displays/Graph";
import { transformPopup } from "../Displays/Popup";
import { transformAudio } from "../Displays/TextToSpeech";

export function transformProp(data:Object, object:HTMLElement):string{

    let html = '';
    switch(data.type){
        case "popup":
            html = transformPopup(data);
            break;
        case "audio":
            html = transformAudio(data);
        break;
        case "graph":
            html = transformGraph(data, object);
        break;
        case "chart":
            html = transformChart(data, object);
        break;

    }

    return html;
}